/** Digital Twin production workspace. Work-order drafts use the наряд UUID. */
export const PRODUCTION_WORKSPACE = 'master'

export function isDraftWorkspace(workspaceId: string): boolean {
  return workspaceId !== PRODUCTION_WORKSPACE
}

/** Path segment for GET .../drafts/{id}. Production is not a DatacenterDraft id. */
export function floorPlanDraftSegment(workspaceId: string): string {
  return isDraftWorkspace(workspaceId) ? workspaceId : 'active'
}

/** Header workspace <select> options. Dead overlay UUIDs do not belong here. */
export function headerWorkspaceOptions(): { id: string; label: string }[] {
  return [{ id: PRODUCTION_WORKSPACE, label: `${PRODUCTION_WORKSPACE} (Production)` }]
}

/** Select value is always Production; WO sandbox is badge + Reset, not an option. */
export function headerSelectValue(_workspaceId: string): string {
  return PRODUCTION_WORKSPACE
}

export function showSandboxBadge(workspaceId: string): boolean {
  return isDraftWorkspace(workspaceId)
}
